import React from "react";
import EpisodeArtwork from "./EpisodeArtwork";
import { Heart, Play } from "lucide-react";

interface EpisodeInfoProps {
  title?: string;
  imageUrl?: string;
  listens?: number;
  likes?: number;
}

const EpisodeInfo = ({
  title = "Episode Title",
  imageUrl,
  listens = 0,
  likes = 0,
}: EpisodeInfoProps) => {
  const formatNumber = (num: number) => {
    if (num >= 1000000) {
      return `${(num / 1000000).toFixed(1)}M`;
    }
    if (num >= 1000) {
      return `${(num / 1000).toFixed(1)}K`;
    }
    return num.toString();
  };

  return (
    <div className="flex items-start gap-4">
      <EpisodeArtwork imageUrl={imageUrl} altText={title} size={72} />
      <div className="flex-1 min-w-0">
        <h2 className="text-base font-semibold text-gray-900 line-clamp-2">
          {title}
        </h2>
        <div className="flex items-center gap-3 mt-1">
          <div className="flex items-center gap-1 text-xs text-gray-600">
            <Play className="h-3 w-3" />
            <span>{formatNumber(listens)}</span>
          </div>
          <div className="flex items-center gap-1 text-xs text-gray-600">
            <Heart className="h-3 w-3" />
            <span>{formatNumber(likes)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EpisodeInfo;
